import React from 'react';

import { H, Section } from "react-headings";

// use in place of Section for places where the heading exists conditionally.
// if the component is *only* the heading, noHeading isn't needed
// if the component has the conditional heading as a child, specify noHeading
function SmartSection({component,children,noHeading}) {
    if (noHeading || !component) {
        return (
            <>
              {component}
              {children}
            </>
      );
    }
    return (
        <Section component={component}>
            {children}
        </Section>
    )
}

export { H, Section, SmartSection };

